<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()" (keydown.enter)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>
    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()" matTooltip="Add Documents"
          *ngIf="(qmsservice.moduleName == 'AU' || (message.showDocumentActionButtons || this.activity.pagename == 'Action')) || this.qmsservice.selectedTabName == 'Preliminary Actions'">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px; text-align: center;"
      [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
      <div style="display: flex;">
        <div>
          <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
        </div>
      </div>
    </th>
    <th id="grid-header-container"
      *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
      [ngStyle]="{'min-width': taskDocumentsDataForGridData.width, 'max-width': taskDocumentsDataForGridData.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
      class="sticky-dynamic-col1">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span> {{taskDocumentsDataForGridData.fieldColumnarray }}</span>
        <div class="d-flex gap-2 align-items-center">
          <div class="sort" (click)="sortColumn(columnLists.columnsListarray[ix],taskDocumentsDataForGridData)"
            (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],taskDocumentsDataForGridData)">
            <div><i *ngIf="sortedDisplayColumn==taskDocumentsDataForGridData.fieldColumnarray && sortDirection=='asc'"
                class='fas fa-angle-up' style='font-size:11px'></i></div>
            <div><i *ngIf="sortedDisplayColumn==taskDocumentsDataForGridData.fieldColumnarray && sortDirection=='desc'"
                class='fas fa-angle-down' style='font-size:11px'></i></div>
            <img *ngIf="sortedDisplayColumn!=taskDocumentsDataForGridData.fieldColumnarray"
              src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <th id="menu" class="sticky-col first-col"></th>
    <!-- search input row is added -->
    <tr>
      <td [class]="
                makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
              "></td>
      <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
        class="sticky-dynamic-col1">
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
        </div>
      </td>
    </tr>
    <!-- data row -->
    <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
      [class.highlightRow]="list.childCheckBoxs == true">
      <td style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, list, idx)">
          </div>
        </div>
      </td>
      <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
        class="sticky-dynamic-row1"
        [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
        <span *ngIf="key.columnsListarray=='DOCUMENT_BLOB' && list.DOCUMENT_BLOB!=undefined &&list.DOCUMENT_BLOB!=''">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="viewDocument(list)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>
        <span *ngIf="key.dataType=='CHECKBOX'">
          <div class="gridCheckBoxes">
            <img *ngIf="list[key.columnsListarray]" src="../../../assets/img/cr_module/accessSymbol.svg" width="16"
              height="16" alt="access" />
            <img *ngIf="list[key.columnsListarray] == false" src="../../../assets/img/cr_module/noAcessSymbol.svg"
              width="16" height="16" alt="no access" />
          </div>
        </span>

        <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(list,key.columnsListarray,columnLists.fieldColumnarray[i].fieldColumnarray)">
              <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
              <span class="ms-1">View</span>
            </button>
          </div>
        </span>

        <span
          *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && key.columnsListarray!='DOCUMENT_BLOB'  && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa'">{{
          list[key.columnsListarray] }}</span>
        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
      </td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <ng-container
            *ngIf="list.CREATED_BY == loggedUserId && (qmsservice.moduleName == 'AU' || (message.showDocumentActionButtons || qmsservice.selectedTabName == 'Actions'))">
            <i class=" fa-solid fa-pencil" matTooltip="Edit Documents" style="margin-left: 5px;"
              (click)="openEditPopup(list)" (keydown.enter)="openEditPopup(list)"></i>
            <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Documents" style="margin-left: 5px;"
              (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
          </ng-container>
          <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('individual',list)"
            (keydown.enter)="openAuditTrail('individual',list)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>

<ng-template #updateMessagePopup>
  <div class="updateMessage-container">
    <span>Data has been not changed...</span>
  </div>
</ng-template>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-2" *ngIf="makeEvidenceAttachedToggleVisible">
          <div><label for="email">Evidence Attached</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="isEvidenceAttachedCheched"
            (change)="onEvidenceAttached($event)">
            <span class="active-inActive-container" *ngIf="isEvidenceAttachedCheched==true"
              [ngStyle]="isEvidenceAttachedCheched==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="isEvidenceAttachedCheched==false"
              [ngStyle]="isEvidenceAttachedCheched==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <div><label id="documentType-validation" for="email">
              <!-- Document Type -->{{dynamicLabel['DOCUMENT_TYPE']}}
            </label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedDocumentType" (closed)="documentTypeTxt=''"
            (click)="focusmethod('documentTypeSearch')" (keydown.enter)="focusmethod('documentTypeSearch')"
            [disabled]="!isEvidenceAttachedCheched || disabletypeField"
            [ngClass]="{'odd-item-mat-select':isdocumentTypeOdd==selectedDocumentType}">
            <input type="search" id="documentTypeSearch" class="dropdownsearchstyle" [(ngModel)]="documentTypeTxt"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of documentTypeListDropdown| assessmentSearch :documentTypeTxt"
              (onSelectionChange)="onDocumentTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-4" *ngIf="isEvidenceAttachedCheched">
          <div><label id="documentName-validation" for="email">
              <!-- Document Name -->{{dynamicLabel['DOCUMENT_NAME']}}
            </label><span class="mandatory-symbol">*</span></div>
          <input id="documentName" class="input-filed-continers" type="text"
            [(ngModel)]="taskDocumentsFieldData.documentName" (focusout)="onFieldFocusout()">
        </div>
        <div class="col-md-3" id="upload-btn-wrapper" *ngIf="isEvidenceAttachedCheched">
          <button id="uploadButton" class="btn" style="height: 43px;" (click)="openFileDialog()">Choose
            document...</button>
          <input id="uploadInputValue" style="display: none;" #fileInput type="file" name="myfile"
            (change)="uploadDocuments($event)" title="" />
          <div class="upload-val-container">
            <span id="template-mandatory-icon" class="fa-solid fa-circle-exclamation"></span>
            <span id="template-mandatory-msg">Document upload is mandatory</span>
            <span id="template-success-icon" class="far fa-check-circle"></span>
            <span id="template-success-msg">Document uploaded successfully</span>
            <span id="preDocument-validation" *ngIf="visibleEditButton"
              [ngStyle]="preUploadedDocument==''?{'opacity':'0'} : {'color': 'green'}">
              {{ preDocumentName }}.{{ preDocumentExtention }}
            </span>
          </div>
        </div>
        <div class="col-md-4 field-styles" *ngIf="!isEvidenceAttachedCheched">
          <div><label id="comments-validation" for="email">
              <!-- Comments -->{{dynamicLabel['COMMENTS']}}
            </label><span class="mandatory-symbol">*</span></div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="taskDocumentsFieldData.comments" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(taskDocumentsFieldData)"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(taskDocumentsFieldData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="taskDocumentsFieldData.deleteReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
<app-editor #clobViewPopup></app-editor>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>
